import React from 'react'
import SALink from 'components/SALink'
import classNames from 'classnames'
import { capitalizeString } from 'lib/helpers'

const Component = (props: Record<string, any>) => {
  const { country, firstName, isSeoValid, lastName, profileUrl } = props
  const capitalizedName = capitalizeString(`${firstName} ${lastName}`)

  return (
    <div data-style='column' data-type='artist-info'>
      <div data-type='artwork-details'>
        <div data-type='main'>
          <SALink
            alt={profileUrl}
            data-type='profile-url'
            href={profileUrl}
            rel={isSeoValid ? null : 'nofollow'}
            title={`View artist ${firstName} ${lastName} profile`}
          >
            <p
              className={classNames('defaultTypographyXSmallOrH6', 'defaultTextTruncate')}
              data-type='artist-name'
              style={{ color: '#1e1e1e' }}
            >
              {capitalizedName}
            </p>
          </SALink>
        </div>
        <div data-type='sub'>
          <p className={classNames('defaultTypographyXSmall', 'defaultTextTruncate')}>{country}</p>
        </div>
      </div>
    </div>
  )
}

export default Component
